import React from 'react';

export default function Hero() {
  return (
    <section
      style={{
        background: 'linear-gradient(160deg, #B8D8F0 0%, #C4BCEE 55%, #A89EE0 100%)',
        paddingBottom: '4rem',
        position: 'relative',
        clipPath: 'ellipse(100% 97% at 50% 0%)',
      }}
    >
      <div className="content-column" style={{ paddingTop: '3rem' }}>
        {/* Location badge */}
        <div style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: '0.4rem',
          background: 'rgba(255,255,255,0.45)',
          borderRadius: '2rem',
          padding: '0.35rem 0.85rem',
          marginBottom: '2rem',
          fontSize: '0.78rem',
          fontWeight: 500,
          color: '#3A3580',
          backdropFilter: 'blur(4px)',
        }}>
          <span style={{ fontSize: '0.9rem' }}>📍</span>
          Sumner · Redcliffs · Lyttelton · Mt Pleasant · Ferrymead
        </div>

        {/* Brand name */}
        <h1 style={{
          fontFamily: "'Playfair Display', serif",
          fontWeight: 600,
          fontSize: '2.75rem',
          lineHeight: 1.1,
          color: '#1A1530',
          marginBottom: '0.25rem',
          marginTop: 0,
        }}>
          She'll Be Right
        </h1>
        <h1 style={{
          fontFamily: "'Playfair Display', serif",
          fontWeight: 400,
          fontStyle: 'italic',
          fontSize: '2.75rem',
          lineHeight: 1.1,
          color: '#3A3580',
          marginTop: 0,
          marginBottom: '1.5rem',
        }}>
          Assistance
        </h1>

        {/* Unified pitch — personal + business in one statement */}
        <p style={{
          fontFamily: "'DM Sans', sans-serif",
          fontSize: '1.05rem',
          fontWeight: 400,
          color: '#1A1530',
          lineHeight: 1.7,
          marginBottom: '0.75rem',
          marginTop: 0,
          maxWidth: '600px',
        }}>
          Have you ever thought about having your own assistant? Someone to give you more time for what matters most — or to step in when the unexpected comes up.
        </p>

        <p style={{
          fontFamily: "'DM Sans', sans-serif",
          fontSize: '1.05rem',
          fontWeight: 400,
          color: '#1A1530',
          lineHeight: 1.7,
          marginBottom: '1rem',
          marginTop: 0,
          maxWidth: '600px',
        }}>
          And if you're running a small business — someone who can help with your data, your admin, following up providers, or other tasks you keep putting off.{' '}
          <strong style={{ fontWeight: 600 }}>No commitments.</strong>
        </p>

        {/* Motivational line */}
        <p style={{
          fontFamily: "'Playfair Display', serif",
          fontSize: '1rem',
          fontWeight: 400,
          fontStyle: 'italic',
          color: '#000000',
          lineHeight: 1.65,
          marginBottom: '1.75rem',
          marginTop: 0,
          maxWidth: '520px',
        }}>
          The busier you get, the faster things start slipping. You don't have to do everything yourself.
        </p>

        {/* Pathway buttons */}
        <div style={{ display: 'flex', gap: '0.75rem', flexWrap: 'wrap' }}>
          <a
            href="#home-help"
            className="btn-amber"
          >
            Help around home
            <svg width="14" height="14" viewBox="0 0 16 16" fill="none">
              <path d="M8 3L13 8L8 13" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </a>
          <a
            href="#business-support"
            style={{
              background: 'rgba(255,255,255,0.5)',
              color: '#3A3580',
              fontFamily: "'DM Sans', sans-serif",
              fontWeight: 600,
              fontSize: '0.95rem',
              padding: '0.85rem 1.75rem',
              borderRadius: '2rem',
              border: '1px solid rgba(58,53,128,0.2)',
              cursor: 'pointer',
              display: 'inline-flex',
              alignItems: 'center',
              gap: '0.5rem',
              transition: 'opacity 0.2s',
              textDecoration: 'none',
              backdropFilter: 'blur(4px)',
            }}
          >
            Help in my business
            <svg width="14" height="14" viewBox="0 0 16 16" fill="none">
              <path d="M8 3L13 8L8 13" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </a>
        </div>
      </div>
    </section>
  );
}
